import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ObservationDetails } from 'src/app/apiAndObjects/objects/observationDetails';

@Component({
  selector: 'app-contribute-response',
  templateUrl: './contribute-response.component.html',
  styleUrls: ['./contribute-response.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, MatProgressBarModule],
})
export class ContributeResponseComponent implements OnInit {
  /////////////////////// spinner controls
  color = 'primary';
  mode = 'indeterminate';
  // value = 10;`
  // bufferValue = 20;
  /////////////////////// spinner controls

  public show: 'loading' | 'error' | 'success' = 'loading';

  constructor(@Inject(MAT_DIALOG_DATA) public dataObjects: object) {}

  ngOnInit() {
    const responsePromise: Promise<ObservationDetails> = this.dataObjects['obsDetailsPromise'];
    if (null != responsePromise) {
      responsePromise.then(() => (this.show = 'success')).catch(() => (this.show = 'error'));
    }
  }
}
